// extracted by mini-css-extract-plugin
export default {"root":"ht4iFJcr0k"};